import { storage, StorageKeys } from '@/shared/lib/storage'

export const DEFAULT_LOCALE = 'pt-BR'
export const SUPPORTED_LOCALES = ['pt-BR', 'en'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

function isSupportedLocale(value: unknown): value is SupportedLocale {
  return (
    typeof value === 'string' &&
    (SUPPORTED_LOCALES as readonly string[]).includes(value)
  )
}

export function detectBrowserLocale(): SupportedLocale {
  if (typeof navigator === 'undefined' || !navigator.language) {
    return DEFAULT_LOCALE
  }
  const lang = navigator.language.toLowerCase()
  if (lang.startsWith('pt')) return 'pt-BR'
  if (lang.startsWith('en')) return 'en'
  return DEFAULT_LOCALE
}

export function getStoredLocale(): SupportedLocale | null {
  const stored = storage.local.get<string>(StorageKeys.USER_LANG)
  return isSupportedLocale(stored) ? stored : null
}

export function setStoredLocale(locale: SupportedLocale | string): void {
  if (isSupportedLocale(locale)) {
    storage.local.set(StorageKeys.USER_LANG, locale)
  }
}

export function resolveInitialLocale(): SupportedLocale {
  return getStoredLocale() ?? detectBrowserLocale()
}

export function setHtmlLang(locale: SupportedLocale | string): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale
  }
}
